export default "__VITE_ASSET__C4ngkqE4__"